import { observer } from "mobx-react-lite";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import RegionDetailViewModel from "viewModels/timeCharges/distributorEnums/regions/regionDetailViewModel";
import EditableDetailView from "views/common/editableDetailView";
import RegionForm from "./regionForm";

const RegionDetailView: ViewComponent<RegionDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<RegionForm vm={vm} />} />;
});

registerView(RegionDetailView, RegionDetailViewModel);
